import { MarketCategory } from '@interfaces/marketCategory.interface';

import api from './';

export const { useGetMarketCategoriesQuery } = api.injectEndpoints({
  endpoints: (build) => ({
    getMarketCategories: build.query<MarketCategory[], void>({
      query: () => ({ url: 'market-category' }),
    }),
  }),
});
